// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ypRNa","controls":"styles_controls__2CFAH","charLimit":"styles_charLimit__3LdKP","input":"styles_input__1QHtB","send":"styles_send__JS4tB"};